export const fr = {
    common: {
        invest: "Investir",
        details: "Détails",
        contact: "Contact",
        home: "Accueil",
        properties: "Propriétés",
        pricing: "Tarification",
        blog: "Blog",
        agents: "Agents",
        contactUs: "Contactez-nous",
        login: "Connexion",
        signup: "S'inscrire",
        logout: "Déconnexion",
        viewAll: "Voir toutes les propriétés",
        readyToInvest: "Prêt à investir ?",
        getStarted: "Commencer",
    },
    home: {
        heroTitle: "Trouvez la maison de vos rêves",
        heroSubtitle: "Nous vous aidons à trouver les meilleures propriétés en ville, transformant vos rêves en réalité.",
        whyInvestTitle: "Pourquoi investir dans l'immobilier ?",
        featuredProperties: "Propriétés en vedette",
        featuredSubtitle: "Propriétés sélectionnées par notre équipe",
        investmentPlansTitle: "Niveaux d'Investissement",
        investmentPlansSubtitle: "Choisissez un niveau d'investissement qui correspond à votre stratégie. Les niveaux supérieurs offrent des périodes de blocage de capital plus courtes.",
        pricingCTA: "Découvrez le niveau d'investissement idéal pour vos objectifs financiers, avec des conditions flexibles et des rendements compétitifs.",
        viewPricing: "Voir les Niveaux",
        exploreProperties: "Explorer les Opportunités",
    },
    whyInvest: {
        secure: "Investissement sécurisé",
        secureDesc: "Soyez tranquille avec nos solutions d'investissement sécurisées, votre avenir financier est protégé",
        transparent: "Plateforme transparente",
        transparentDesc: "Découvrez la confiance d'une plateforme transparente pour votre tranquillité d'esprit",
        passive: "Revenu passif",
        passiveDesc: "Explorez les opportunités pour générer des sources de revenus passifs",
        support: "Soutien",
        supportDesc: "Comptez sur notre équipe de soutien dédiée pour une assistance rapide et fiable",
    },
    pricing: {
        starter: "Plan de départ",
        growth: "Plan de croissance",
        premium: "Plan Premium",
        benefits: {
            noFees: "Pas de frais cachés",
            support: "Support client 24/7",
            secure: "Paiements blockchain sécurisés",
            flexible: "Conditions d'investissement flexibles",
        }
    },
    investment: {
        amount: "Montant de l'investissement",
        period: "Période d'investissement",
        confirm: "Confirmer le paiement",
        minAmountError: "Le montant minimum d'investissement est de 1 000 $",
        confirmTitle: "Réviser et compléter l'investissement",
        awaitingConfirmation: "En attente de confirmation du paiement",
        statusPending: "Statut : En attente de confirmation",
        viewMyInvestments: "Voir mes investissements",
    }
};
